export default "__VITE_ASSET__AVEvyAx3__"